package com.wintermar.inspection.feature.util.template_status

import androidx.compose.ui.graphics.Color

data class TemplateStatusContentModel(
    val label: String,
    val labelColor: Color,
    val backgroundColor: Color = Color.Transparent,
    val borderColor: Color = Color.Transparent
)
